export default "__VITE_ASSET__f626bb7f__"